import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/paas.png'


const _hoisted_1 = { class: "headL" }
const _hoisted_2 = { class: "logoImg" }
const _hoisted_3 = { class: "headSearch" }
const _hoisted_4 = { class: "headR" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_btn = _resolveComponent("search-btn")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "heads",
    class: _normalizeClass(["head", {'currentScroll':_ctx.isScroll,isArticle: _ctx.isArticle,'isShoSearch':_ctx.showSearch}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToHome && _ctx.handleToHome(...args))),
          style: {"cursor":"pointer","height":"14px"},
          src: _imports_0,
          alt: "logo"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.showSearch||_ctx.articleSearch)
        ? (_openBlock(), _createBlock(_component_search_btn, {
            key: 0,
            ref: "searchBtn",
            topSearch: true,
            searchHeight: 43,
            searchBtnHeight: true
          }, null, 512))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        class: "articleSix",
        href: "https://docs.awspaas.com/help/index.html",
        target: "_blank"
      }, "访问6平台文档", -1)),
      _createVNode(_component_el_button, {
        class: "visitBtn",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick(_ctx.platformJson.btnUrl)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.platformJson.btnName), 1)
        ]),
        _: 1
      })
    ])
  ], 2))
}